import {Component, ChangeDetectionStrategy} from '@angular/core';
import {Dialog} from '../../../../../interfaces/dialog/dialog';
import {DialogParams} from '../../../../../interfaces/dialog/dialog-params';
import { DatePipe } from '@angular/common';
import {AsyncCommand} from '../../../../../models/async-command';
import { KeepHtmlPipe } from '../../../../../pipes/keep-html.pipe';

@Component({
  selector: 'app-async-command-detail',
  imports: [
    DatePipe,
    KeepHtmlPipe
],
  templateUrl: './async-command-detail.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './async-command-detail.component.scss'
})
export class AsyncCommandDetailComponent implements Dialog {
  asyncCommand: AsyncCommand | null = null;

  onDialogInit(params: DialogParams): void {
    this.asyncCommand = params.data.asyncCommand;
  }
}
